import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Main from "./Main";

import {
  useGetRateAdjustmentCaseCorpListQuery,
  useGetRateAdjustmentCaseMerchantsListQuery,
  useGetDivisionQuery,
} from "../../features/api";

import {
  DivisionDict,
  getDivisionItems,
  getDivisionLabel,
} from "../default-constants";
import { MerchantService } from "../../features/api-interfaces";

//各APIによるデータ取得
export const Update = () => {
  // 情報取得API呼び出し
  const { rateAdjustmentCaseNo } = useParams();
  const no = rateAdjustmentCaseNo as string;

  //親のデータを取得(事業者情報)
  const { data: rateAdjustmentCaseData, refetch: refetch1 } =
    useGetRateAdjustmentCaseCorpListQuery(no);

  //子のデータを取得（加盟店の情報）
  const {
    data: merchantList,
    refetch: refetch2,
    isFetching,
  } = useGetRateAdjustmentCaseMerchantsListQuery(no);

  // 共通データを取得
  // 区分取得API呼び出し(親区分コード：3:契約サービス区分コード)
  const { data: contractServiceDivisions } = useGetDivisionQuery("3");

  // 一覧データの加工
  const [listData, setListData] = useState([] as MerchantService[]);

  useEffect(() => {
    refetch1();
    refetch2();
  }, [refetch1, refetch2]);

  useEffect(() => {
    const contractServiceKbnItems: DivisionDict[] = getDivisionItems(
      contractServiceDivisions
    );
    const rateAdjustmentCaseListMerchantList = merchantList
      ? merchantList.map((item, index) => ({
          ...item,
          contractServiceName: getDivisionLabel(
            contractServiceKbnItems,
            item.contractServiceCode
          ),
          no: index + 1,
        }))
      : [];
    setListData(rateAdjustmentCaseListMerchantList);
  }, [merchantList, contractServiceDivisions]);

  return (
    <Main
      rateAdjustmentCaseDataList={rateAdjustmentCaseData} //親のデータ
      merchantList={listData} //子（加盟店）のデータ
      rateAdjustmentCaseNo={rateAdjustmentCaseNo}
      isFetching={isFetching}
    />
  );
};
